/* Decorative previews follow Dawn's existing slideshow controls and autoplay. */
if (!customElements.get('bm-peek-stage')) {
  customElements.define('bm-peek-stage', class extends HTMLElement {
    connectedCallback() {
      this.slideshow = this.closest('slideshow-component');
      if (!this.slideshow) return;
      this.onSlide = (event) => this.updatePreviews(event.detail.currentPage - 1);
      this.slideshow.addEventListener('slideChanged', this.onSlide);
      this.updatePreviews((this.slideshow.currentPage || 1) - 1);
    }

    disconnectedCallback() {
      this.slideshow?.removeEventListener('slideChanged', this.onSlide);
    }

    updatePreviews(index) {
      const slides = Array.from(this.querySelectorAll('.slideshow__slide'));
      if (slides.length < 2) return;
      const targets = [this.querySelector('.bm-peek--previous'), this.querySelector('.bm-peek--next')];
      [index - 1, index + 1].forEach((neighbor, side) => {
        const slide = slides[(neighbor + slides.length) % slides.length];
        const image = slide.querySelector('.slideshow__media img') ||
          slide.querySelector('template[data-bm-deferred-slide]')?.content.querySelector('img');
        const target = targets[side];
        if (!target) return;
        if (!image) {
          target.removeAttribute('srcset');
          target.removeAttribute('src');
          return;
        }
        target.sizes = '(max-width: 749px) 86vw, (min-width: 1292px) 930px, 72vw';
        target.srcset = image.getAttribute('srcset') || '';
        target.src = image.getAttribute('src');
      });
    }
  });
}
